import { env } from '@/env';
import type {
  NeedHelpRequset,
  RegisterRequset,
  SMSVerificationRequset
} from '@/models/interface/register';
import type { ApiDataResponse, ApiResponse } from '@/utils/api';
import type { ApiResponseModel } from '@/utils/api/models/api-response-model';
import axios, { AxiosError } from 'axios';

axios.interceptors.response.use(
  (response) => {
    if (response.data.status !== 200) {
    }
    return response;
  },
  (error) => {
    const e = error as AxiosError<ApiResponseModel<string>>;

    // 如果有 response，返回其 data，否則返回一個默認的錯誤信息
    if (e.response) {
      return e.response;
    } else {
      return Promise.reject({ message: 'An unknown error occurred' });
    }
  }
);
/**
 * 登入 API
 */
export class LoginService {
  private baseUrl = env.apiBaseUrl;
  /**
   * 發送簡訊驗證碼
   */
  smsVerification(userData: SMSVerificationRequset): Promise<ApiDataResponse<string>> {
    return axios.post<ApiResponseModel<string>>(
      `${this.baseUrl}/Auth/SimpleSMSVerification`,
      userData
    );
  }
  /**
   * 註冊
   */
  register(registData: RegisterRequset): Promise<ApiDataResponse<string>> {
    return axios.post(`${this.baseUrl}/Auth/SimpleRegister`, registData);
  }
  /**
   * 未收到驗證碼
   */
  needHelp(data: NeedHelpRequset): Promise<ApiResponse> {
    return axios.post(`${this.baseUrl}/Auth/NeedHelp?tel=${data.tel}`);
  }
}
